module.exports = __webpack_public_path__ + "static/simulacao-78432806f27da15f14e63894584febb2.jpg";